
import _Vue from 'vue'
import formCreate from './components/formCreate.vue'
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
formCreate.install = Vue => {
  if (!Vue) {
    window.Vue = Vue = _Vue
  }
  Vue.component(formCreate.name, formCreate)
}
export default formCreate;